<script>
import { HERO_CHAT } from '@modules/aawz-intelligence-v2/constants/TextChat'

export default {
  name: 'IntelligenceV2ChatHero',
  props: {
    // Primeira linha, em cinza. Fixa hoje; prop para o dia em que virar
    // "Bom dia, Herik" sem tocar no componente.
    saudacao: {
      type: String,
      default: HERO_CHAT.saudacao,
    },
    // Segunda linha, em escuro. Vem do agente selecionado (`Agentes.headline`).
    headline: {
      type: String,
      default: HERO_CHAT.headline,
    },
  },
}
</script>

<template>
  <div class="chat-hero">
    <div class="chat-hero__line ia-texto-hero chat-hero__line--saudacao">{{ saudacao }}</div>
    <div class="chat-hero__line ia-texto-hero chat-hero__line--headline">{{ headline }}</div>
  </div>
</template>

<style lang="sass" scoped>

.chat-hero__line--saudacao
  // ★ --neutral-600 (4.47 sobre --ia-content-bg) é CONFORME aqui, apesar de a
  // tabela de `_controls.sass` marcá-lo como proibido nas superfícies quentes:
  // aquela tabela usa o limiar de texto NORMAL (4.5), e a saudação tem 40px.
  // Pela WCAG 1.4.3 isso é texto grande, cujo mínimo é 3.0 — o próprio
  // protótipo opera em 3.34. Já esteve em --neutral-700 (7.15) por eu ter
  // aplicado o limiar errado, e ficou visivelmente mais escuro que o desenho.
  color: var(--neutral-600)

.chat-hero__line--headline
  color: var(--neutral-900)
</style>
